import React, { ComponentPropsWithoutRef } from "react"
import PublicAreaModal from "../PublicAreaModal/PublicAreaModal"
import { useECommerceMachine } from "../../app-core/_common/machines/machines-context"

type Props = Pick<ComponentPropsWithoutRef<typeof PublicAreaModal>, "areaType" | "areaKey">

const AppPublicAreaModal: React.FC<Props> = (props) => {
    const [state] = useECommerceMachine()
    const { locale, sanityContent } = state.context

    return (
        <PublicAreaModal
            locale={locale}
            shipId={sanityContent.cruiseData.ship._id}
            shipVersionKey={sanityContent.cruiseData.ship.version._key}
            {...props}
        />
    )
}

export default AppPublicAreaModal
